// src/data/photos.js
// Photos are served from /public/photos/*
// Reference them by URL paths (NOT imports), so builds are fast and consistent.

const makePhoto = ({ collection, filename, category, caption, alt }) => ({
  id: `${collection}-${filename}`,
  filename,
  // public/ is the web root, so /photos/... maps to public/photos/...
  src: `/photos/${collection}/${filename}`,
  alt,
  caption,
  category,
  collection,
});

// Sort Golden Hour: photo.jpg first, then photo1.jpg, photo2.jpg...
const goldenOrder = (filename) => {
  const base = filename.replace(/\.[^/.]+$/, "").toLowerCase();
  if (base === "photo") return 0;
  const m = base.match(/(\d+)$/);
  return m ? Number(m[1]) : 9999;
};

// ✅ Update these arrays to match what actually exists in:
// public/photos/golden_hour
// public/photos/photos
//
// Tip: Keep filenames exactly (case-sensitive on Netlify).
const GOLDEN_HOUR_FILES = [
  // example:
  // "photo.jpg",
  // "photo1.jpg",
  // "photo2.jpg",
  "photo3.jpg",
  "photo4.jpg",
  "photo5.jpg",
  "photo6.jpg",
  "photo8.jpg",
  "photo12.jpg",
  "photo13.jpg",
  "photo15.jpg",
  "photo16.jpg",
  "photo18.jpg",
  "photo20.jpg",
  "photo21.jpg",
  "photo23.jpg",
  "photo24.jpg",
  "photo25.jpg",
  "photo26.jpg",
  "photo27.jpg",
  "photo28.jpg",
  "photo29.jpg",
  "photo31.jpg",
  "photo32.jpg",
  "photo34.jpg",
  "photo35.jpg",
  "photo36.jpg",
];

const SUPPORTING_FILES = [
  // example:
  // "photo1.jpg",
  // "photo2.jpg",
  "firework1.jpg",
  "firework2.jpg",
  "motorcycle.jpg",
  "photo1.jpg",
  "photo2.jpg",
  "photo3.jpg",
  "photo4.jpg",
  "photo5.jpg",
  "photo6.jpg",
  "photo7.jpg",
  "photo8.jpg",
  "photo10.jpg",
  "photo12.jpg",
  "photo13.jpg",
  "photo14.jpg",
  "photo15.jpg",
];

// Build lists
const goldenHourPhotos = GOLDEN_HOUR_FILES
  .slice()
  .sort((a, b) => goldenOrder(a) - goldenOrder(b))
  .map((filename) =>
    makePhoto({
      collection: "golden_hour",
      filename,
      category: "couples",
      caption: "Couples & Weddings",
      alt: "Couples and wedding photography",
    })
  );

const supportingPhotos = SUPPORTING_FILES
  .slice()
  .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
  .map((filename) =>
    makePhoto({
      collection: "photos", // maps to public/photos/photos/*
      filename,
      category: "lifestyle_events",
      caption: "Lifestyle & Events",
      alt: "Lifestyle and event photography",
    })
  );

// ✅ Fix for Netlify/CI ESLint rule: no anonymous default export
const photos = [...goldenHourPhotos, ...supportingPhotos];

export default photos;